import React from 'react'
import { Language } from './data/types'

interface FlowStep {
    icon: string
    title: { pt: string; en: string }
    endpoint?: string
    description: { pt: string; en: string }
    color: string
}

interface FlowDiagramProps {
    steps: FlowStep[]
    language: Language
}

const FlowDiagram: React.FC<FlowDiagramProps> = ({ steps, language }) => {
    return (
        <div style={{
            backgroundColor: '#f6f8fa',
            padding: '32px',
            borderRadius: '12px',
            marginBottom: '24px'
        }}>
            {steps.map((step, index) => (
                <div key={index}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        marginBottom: '16px'
                    }}>
                        {/* Step number and icon */}
                        <div style={{
                            minWidth: '48px',
                            height: '48px',
                            borderRadius: '12px',
                            background: `linear-gradient(135deg, ${step.color}, ${step.color}dd)`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '24px',
                            boxShadow: `0 4px 12px ${step.color}40`
                        }}>
                            {step.icon}
                        </div>

                        {/* Step content */}
                        <div style={{ flex: 1 }}>
                            <div style={{
                                backgroundColor: '#fff',
                                padding: '16px 20px',
                                borderRadius: '10px',
                                border: '2px solid #e1e4e8',
                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
                            }}>
                                <div style={{
                                    fontWeight: 700,
                                    fontSize: '15px',
                                    color: '#24292e',
                                    marginBottom: '4px'
                                }}>
                                    {step.title[language]}
                                </div>
                                {step.endpoint && (
                                    <div style={{
                                        fontFamily: 'Monaco, Menlo, monospace',
                                        fontSize: '13px',
                                        color: step.color,
                                        fontWeight: 600,
                                        marginBottom: '8px'
                                    }}>
                                        {step.endpoint}
                                    </div>
                                )}
                                <div style={{
                                    fontSize: '13px',
                                    color: '#6a737d',
                                    lineHeight: '1.5'
                                }}>
                                    {step.description[language]}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Arrow between steps */}
                    {index < steps.length - 1 && (
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            margin: '12px 0'
                        }}>
                            <div style={{
                                width: '2px',
                                height: '24px',
                                background: 'linear-gradient(180deg, #10b981 0%, #34d399 100%)',
                                position: 'relative'
                            }}>
                                <div style={{
                                    position: 'absolute',
                                    bottom: '-6px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: 0,
                                    height: 0,
                                    borderLeft: '6px solid transparent',
                                    borderRight: '6px solid transparent',
                                    borderTop: '8px solid #34d399'
                                }} />
                            </div>
                        </div>
                    )}
                </div>
            ))}
        </div>
    )
}

export default FlowDiagram
